// extracted by mini-css-extract-plugin
export default {"container":"pu","content":"qu","btn":"ru","left":"su","head":"tu","subHead":"uu"};
    if(module.hot) {
      // 1714442366394
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  